export enum LogLevel {
  NEVER = Number.MAX_SAFE_INTEGER,
  TRACE = 0,
  DEBUG = 1,
  INFO = 2,
  WARNING = 3,
  ERROR = 4,
}

export enum LogMethod {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
}

export const logLevelMap: { [key: string]: LogLevel } = {
  TRACE: LogLevel.TRACE,
  DEBUG: LogLevel.DEBUG,
  INFO: LogLevel.INFO,
  WARNING: LogLevel.WARNING,
  ERROR: LogLevel.ERROR,
  NEVER: LogLevel.NEVER,
};

export function getLogLevelFromString(level: string): LogLevel {
  return logLevelMap[level.toUpperCase()] ?? LogLevel.NEVER;
}
